import { render } from "./UpgradePlanTrialModal.vue?vue&type=template&id=923a8fd6"
import script from "./UpgradePlanTrialModal.vue?vue&type=script&lang=js"
export * from "./UpgradePlanTrialModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__